import { z } from "zod";
import { Cusip, DateSchema, SecurityId, Ticker } from "../../Types";
export const Registrar = z.enum([
    "FARTHER",
    "TICKER",
    "CUSIP",
    "ISIN",
    "FIGI",
    "BLOOMBERG",
    "BLOOMBERG_COMPOSITE",
    "REUTERS",
    "SEDOL",
    "SEC_CIK",
]);
// Should match Vanadium/src/services/securityMaster/Types.ts
export const SecurityType = z.enum([
    "Stock",
    "MutualFund",
    "SweepFund",
    "CashLike",
    "FartherSecurity",
]);
const SecurityState = z.enum(["Active", "Inactive", "Deleted"]);
const SecurityIdentifierState = z.enum(["Active", "Inactive", "Deleted"]);
const OtherIdentifier = z.object({
    securityId: SecurityId,
    identifier: z.string(),
    registrar: Registrar,
    state: SecurityIdentifierState,
    description: z.string().nullable(),
    updatedAt: DateSchema,
});
const CusipIdentifier = z.object({
    securityId: SecurityId,
    identifier: Cusip,
    registrar: Registrar.extract(["CUSIP"]),
    state: SecurityIdentifierState,
    description: z.string().nullable(),
    updatedAt: DateSchema,
});
const TickerIdentifier = z.object({
    securityId: SecurityId,
    identifier: Ticker,
    registrar: Registrar.extract(["TICKER"]),
    state: SecurityIdentifierState,
    description: z.string().nullable(),
    updatedAt: DateSchema,
});
const Identifier = z.union([
    TickerIdentifier,
    CusipIdentifier,
    OtherIdentifier,
]);
export const Security = z.object({
    id: SecurityId,
    name: z.string().nullable(),
    description: z.string().nullable(),
    type: SecurityType,
    state: SecurityState,
    createdAt: DateSchema,
    updatedAt: DateSchema,
    identifiers: Identifier.array(),
});
//# sourceMappingURL=Types.js.map